import * as React from 'react';
import { noop } from 'vet-bones/utils';

import { ProjectVirtualGraphOptions } from 'src/store/state/projects';

export type LocalVirtualGraphOptionsValue = [
  ProjectVirtualGraphOptions | null,
  React.Dispatch<React.SetStateAction<ProjectVirtualGraphOptions>>
];

export const LocalVirtualGraphOptionsContext =
  React.createContext<LocalVirtualGraphOptionsValue>([null, noop]);

export const useLocalVirtualGraphOptions = () => {
  const localVirtualGraphOptions = React.useContext(
    LocalVirtualGraphOptionsContext
  );
  return localVirtualGraphOptions;
};

export const useLocalVirtualGraphOptionsValue = (
  virtualGraphOptions: ProjectVirtualGraphOptions
): LocalVirtualGraphOptionsValue => {
  const [localVirtualGraphOptions, setLocalVirtualGraphOptions] =
    React.useState<ProjectVirtualGraphOptions>({ ...virtualGraphOptions });
  return [localVirtualGraphOptions, setLocalVirtualGraphOptions];
};
